module.exports = {
  type: {
    MESOS: "MESOS",
    DOCKER: "DOCKER"
  },
  labelMap: {
    DOCKER: "Docker Engine",
    MESOS: "Universal Container Runtime (UCR)"
  }
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ContainerConstants.js